export default __webpack_public_path__ + "static/media/b7.dcae6c58.png";